import { render, staticRenderFns } from "./gameDetails.vue?vue&type=template&id=8e05d202&scoped=true&"
import script from "./gameDetails.vue?vue&type=script&lang=js&"
export * from "./gameDetails.vue?vue&type=script&lang=js&"
import style1 from "./gameDetails.vue?vue&type=style&index=1&id=8e05d202&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e05d202",
  null
  
)

export default component.exports